export const COLLECTION_TOTEM = "totem";
export const COLLECTION_COMPRAS = "compras";
export const COLLECTION_USER_FRANQUEADO = "userFranqueado";
export const COLLECTION_LEADS_CAPTURADOS = "leadsCapturados";
export const COLLECTION_MOLDURAS = "molduras";
export const COLLECTION_CODES = "codes";
export const COLLECTION_CUPONS = "cupons";
export const COLLECTION_PRECOS = "precos";
export const COLLECTION_FOTOS = "fotos";
export const COLLECTION_ERROS = "erros";
export const COLLECTION_PERSONALIZA_TOTEM = "personalizaTotem";
